var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F85050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.337 11.9328C12.7276 12.3233 12.7277 12.9564 12.3372 13.347C11.2187 14.4659 10.457 15.8914 10.1485 17.4432C9.84006 18.995 9.99864 20.6034 10.6042 22.065C11.2098 23.5267 12.2352 24.7759 13.5507 25.6549C14.8662 26.5338 16.4129 27.0029 17.995 27.0029C19.5771 27.0029 21.1238 26.5338 22.4393 25.6549C23.7548 24.7759 24.7802 23.5267 25.3858 22.065C25.9914 20.6034 26.1499 18.995 25.8415 17.4432C25.533 15.8914 24.7713 14.4659 23.6528 13.347C23.2623 12.9564 23.2624 12.3233 23.653 11.9328C24.0436 11.5423 24.6768 11.5424 25.0672 11.933C26.4654 13.3317 27.4175 15.1135 27.8031 17.0532C28.1887 18.993 27.9905 21.0035 27.2335 22.8305C26.4765 24.6576 25.1948 26.2192 23.5504 27.3179C21.9059 28.4165 19.9727 29.0029 17.995 29.0029C16.0173 29.0029 14.0841 28.4165 12.4396 27.3179C10.7952 26.2192 9.51349 24.6576 8.75652 22.8305C7.99954 21.0035 7.80132 18.993 8.18691 17.0532C8.5725 15.1135 9.52458 13.3317 10.9228 11.933C11.3132 11.5424 11.9464 11.5423 12.337 11.9328Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7C18.5523 7 19 7.44772 19 8V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V8C17 7.44772 17.4477 7 18 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.b149bf7bd13eb78945d5fd09f08d74c1.svg";
export { ForwardRef as ReactComponent };